<div class=" addRemove">
    <span (click)="removeFromCart()">
      <img *ngIf="this.product.quantity"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/decrement-active.svg'" alt="DecrementActive | Luminous">
      <img *ngIf="this.product.quantity==0"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/decrement.svg'" alt="Decrement | Luminous">
    </span>
    <span class="user-select-none">{{product.quantity?product.quantity: 0}}</span>
    <span (click)="addToCart()">
      <img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/increment.svg'" alt="Increment | Luminous">
    </span>
  </div>
  